import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import {
  CERTIFICATION_GROUPS,
  CERTIFICATION_COUNT,
} from '../data/certifications';
import SectionHead from './SectionHead';
import PointList from './PointList';
import representativePhoto from '../assets/representative-photo.jpg';
import layout from '../styles/layout.module.css';
import styles from './MessageSection.module.css';

const MessageSection: React.FC = () => {
  const { elementRef, isVisible } = useScrollAnimation<HTMLDivElement>();

  return (
    <section
      id="message"
      className={layout.section}
      aria-labelledby="message-title"
    >
      <div
        ref={elementRef}
        className={`${layout.wrap} ${layout.sectionInner} slide-up ${isVisible ? 'visible' : ''}`}
      >
        <SectionHead
          eyebrow="MESSAGE"
          title="代表コメント"
          titleId="message-title"
          lead="代表取締役 伊原健太から、この会社をつくった理由について。"
        />

        <div className={styles.grid}>
          <div className={styles.person}>
            <img
              src={representativePhoto}
              alt="代表取締役 伊原健太の写真"
              width="240"
              height="240"
              loading="lazy"
              decoding="async"
              className={styles.photo}
            />
            <div className={styles.nameBlock}>
              <p className={styles.name}>伊原 健太</p>
              <p className={styles.kana}>いはら けんた</p>
            </div>
            <p className={styles.role}>
              代表取締役
              <br />
              株式会社eNEW Studio
              <br />元 AWS ソリューションアーキテクト
            </p>
          </div>

          <div className={styles.body}>
            <h3 className={styles.pull}>
              AWSの専門知識を、
              <br />
              もっと身近な選択肢に。
            </h3>

            <div className={styles.paragraphs}>
              <p>
                クラウド技術は日々進化していますが、それを使いこなしてビジネスに活かすには、正しい知識と経験が必要です。私はこれまで、AWS（アマゾン
                ウェブ
                サービス）のソリューションアーキテクトとして、多くの企業の技術課題に向き合ってきました。
              </p>
              <p>
                素晴らしい技術があっても、導入のハードルが高かったり、複雑すぎて運用できないのでは意味がありません。
              </p>
              <p>
                eNEW Studio は、元 AWS 社員としての知見と、AWS 認定 12
                冠の技術力を活かし、
                <strong className={styles.emphasis}>
                  お客様の事業規模に合った、無理のない最適なクラウド設計
                </strong>
                を提案するために設立しました。大規模な開発会社ではありませんが、その分、小回りの利く機動力と、構成もコストも隠さない進め方をお約束します。
              </p>
              <p>
                不透明なコストやブラックボックス化を防ぎ、長く安心して使えるシステム基盤を、ここ金沢から提供します。契約が終わっても困らないように、構成と手順は引き継げる形で残します。あなたのビジネスの「技術パートナー」として、共に歩めることを楽しみにしています。
              </p>
            </div>

            <div className={styles.profile}>
              <p className={styles.label}>プロフィール</p>
              <p className={styles.profileText}>
                2014年より DMM.com
                にてインフラ・開発エンジニアとして大規模トラフィックを支えるシステム構築に従事。その後、アマゾン
                ウェブ サービス ジャパン（AWS
                Japan）に入社。ソリューションアーキテクトとして、主に関西・中部企業へのクラウド導入や技術課題解決、コスト最適化を支援。AWS
                認定 12
                冠に裏打ちされた専門知識と、バックエンドからフロントエンドまで手掛けるフルスタックな開発経験を活かし、2025年に株式会社eNEW
                Studio を設立。
              </p>
            </div>

            <div className={styles.certs}>
              <p className={styles.label}>
                AWS 認定資格 ── {CERTIFICATION_COUNT}
              </p>
              <div className={styles.certGrid}>
                {CERTIFICATION_GROUPS.map((group) => (
                  <div key={group.level} className={styles.certGroup}>
                    <p className={styles.certLevel}>{group.level}</p>
                    <PointList items={group.items} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MessageSection;
